<template>
    <div class="default-input" data-vue-handed :class="{error: errors.length}">
        <div class="default-input__body">
            <input class="default-input__input" :style="inputTopPadding ? `padding-top: ${inputTopPadding}px;` : ''" type="text" v-model="value" :name="name" :inputmode="inputmode" v-mask="maskSettings" :required="required" :placeholder="placeholder" :id="id" :disabled="disabled">
            <label class="default-input__label" ref="inputLabel">{{ label }}</label>
        </div>
        <div class="default-input__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputText",
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        inputmode: {
            type: String,
            default: 'text'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        maskSettings: {
            type: [Object, String, null],
            default: null
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            inputTopPadding: null,
        }
    },
    mounted() {
        this.getInputTopPadding();
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
    },
    methods: {
        getInputTopPadding() {
            if (!this.$refs.inputLabel) return;

            const label = this.$refs.inputLabel;

            const labelHeight = label.offsetHeight;
            const labelPaddingBottom = parseInt(window.getComputedStyle(label).paddingBottom);
            this.inputTopPadding = labelHeight - (labelPaddingBottom / 2);
        }
    }
}
</script>

<style scoped>

</style>